import React from 'react';
import classnames from 'classnames';

export const SortToggle = ({ direction }) => {
  const classes = {fa: true};
  switch(direction){
    case 'ASC':
    case 'DESC':
    case 'UP':
    case 'DOWN':
        classes[`fa-sort-${direction.toLowerCase()}`] = true;
      break;
    default:
        classes['fa-sort'] = true;
      break;
  }
  return (
      <i className={classnames(classes)} />
  );
};
